import { EssentialsCarouselWrapperProps } from '@msc-b2c/interfaces/types';
import EssentialsCarousel from './EssentialsCarousel';
import styles from './essentialscarousel.module.scss';
import { LoginMode } from '@msc-b2c/interfaces/enums';
import { useEffect, useState } from 'react';
import { breakpoints, getActiveSession, useGetBookingQuery } from '@msc-b2c/shared-utils';
import { skipToken } from '@reduxjs/toolkit/query';
import { getDepartureDate, isXDaysBeforeDeparture } from '../utils/myAreaUtils';
import { Text } from '@msc-b2c/shared-components';

export const EssentialsCarouselWrapper = ({
  preTitle,
  title,
  subTitle,
  showInLightLoginDesktop,
  showInLightLoginMobile,
  showInFullLoginDesktop,
  showInFullLoginMobile,
  showSliderMobile,
  showSliderTablet,
  showSliderDesktop,
  showArrowsMobile,
  showArrowsTablet,
  showArrowsDesktop,
  leftArrowIcon,
  rightArrowIcon,
  essentialCardItems,
}: EssentialsCarouselWrapperProps) => {
  const aemConfigurationProps = {
    visibilityOptions: {
      showInLightLoginDesktop,
      showInLightLoginMobile,
      showInFullLoginDesktop,
      showInFullLoginMobile,
    },
    sliderOptions: {
      showSliderMobile,
      showSliderTablet,
      showSliderDesktop,
      showArrowsMobile,
      showArrowsTablet,
      showArrowsDesktop,
      leftArrowIcon,
      rightArrowIcon,
    },
    contentOptions: {
      essentialCardItems,
    },
  };

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= breakpoints.md);

  const { bookingNumber = '' } = getActiveSession();

  const { data: booking } = useGetBookingQuery(bookingNumber || skipToken);

  const removeCarouselSkeleton = () => {
    const skeleton = document.querySelector('.essentials-carousel-skeleton');
    if (skeleton) {
      skeleton.remove(); // Removes the element from the DOM
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= breakpoints.md);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const { loginMode } = getActiveSession();

  if (
    (loginMode === LoginMode.FULL &&
      ((!isMobile && !showInFullLoginDesktop) || (isMobile && !showInFullLoginMobile))) ||
    (loginMode === LoginMode.LIGHT &&
      ((!isMobile && !showInLightLoginDesktop) || (isMobile && !showInLightLoginMobile)))
  ) {
    removeCarouselSkeleton();
    return null;
  }
  // Hide component when the booking is in less than X days before departure
  if (booking && isXDaysBeforeDeparture(getDepartureDate(booking))) {
    removeCarouselSkeleton();
    return null;
  }

  return (
    <div className={styles.essentialsCarouselWrapper}>
      <Text
        text={preTitle}
        styleOption={`text body-small spacer-mb-016 spacer-md-mb-024`}
        tagHtml="p"
      />
      <Text
        text={title}
        styleOption={`text header-m spacer-mb-016 spacer-md-mb-008`}
        tagHtml="p"
      />
      <Text
        text={subTitle}
        styleOption={`text body-default spacer-mb-032 spacer-md-mb-032`}
        tagHtml="p"
      />
      <EssentialsCarousel aemConfigurationProps={aemConfigurationProps} />
    </div>
  );
};

export default EssentialsCarouselWrapper;

EssentialsCarouselWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/essentialscarousel';
